module.exports = __webpack_public_path__ + "img/pic_缺失.cd130a0e.png";